var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwatchbookSolid = function SvgSwatchbookSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v18c0 2.206 1.794 4 4 4s4-1.794 4-4V5zm2 2h4v4H7zm11.9.443-4.398 4.4v2.827l4.396-4.399 2.83 2.829-7.228 7.228V23c0 .056-.007.108-.008.164l10.065-10.062zM7 13h4v4H7zm0 6h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm13.777 0-2 2H25v4H14.777l-1.888 1.889c-.042.042-.092.071-.135.111H27v-8z"
  })));
};
export default SvgSwatchbookSolid;